import { useEffect, useState } from 'react'

type LegalDocs = { terms: string; privacy: string; tokushoho: string; refundPolicy: string }

/**
 * 規約・プライバシーポリシーなどの本文 (10 言語ぶんで約 140KB) を、**開く時にだけ**読み込む。
 *
 * 以前はログイン・登録・プロフィール・店舗ダッシュボードが `constants/legalContent` を静的に
 * import していて、本文が丸ごとメインの JS に入っていた。メインの JS は PWA のキャッシュ上限
 * (2 MiB — vite.config.ts のガードレール) の際まで来ており、ポリシーに 2 行足しただけで超えて
 * ビルドが落ちた (#2004)。本文が要るのはモーダルを開いた時だけなので、そこで読む。
 *
 * `enabled` が true になって初めて読み込む。読み込むまでは null (呼び出し側が「読み込み中」を出す)。
 * 対応していない言語は英語にフォールバックする (実際には 10 言語すべてに本文がある)。
 */
export function useLegalContent(locale: string, enabled: boolean): LegalDocs | null {
  const [all, setAll] = useState<Record<string, LegalDocs> | null>(null)

  useEffect(() => {
    if (!enabled || all) return
    let cancelled = false
    import('../constants/legalContent')
      .then((m) => { if (!cancelled) setAll(m.LEGAL_CONTENT) })
      .catch((e) => console.error('[useLegalContent] load failed', e))
    return () => { cancelled = true }
  }, [enabled, all])

  return all ? (all[locale] || all.en) : null
}
